import _debounce from "lodash/debounce";
import { DEFAULT_PROVIDER_SEARCH_DEBOUNCE } from "../constants";
import { updateProviderSearchQuery, searchProviders } from "../actions/yodlee";
import { getProviderSearchQuery, getShouldSearchProviders } from "../selectors";
/**
 * Listens for updateProviderSearchQuery action and dispatches getProviderSearchQuery if
 * necessary.
 * @name createProviderSearchMiddleware
 * @param  {number} [options.debounce] the amount in ms to debounce searching.
 * @return {ReduxMiddleware}
 */

export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$debounce = _ref.debounce,
      debounce = _ref$debounce === void 0 ? DEFAULT_PROVIDER_SEARCH_DEBOUNCE : _ref$debounce;

  return function (_ref2) {
    var dispatch = _ref2.dispatch,
        getState = _ref2.getState;

    var debouncedSearch = _debounce(function () {
      var state = getState();

      if (getShouldSearchProviders(state.identity)) {
        var query = getProviderSearchQuery(state.identity);
        dispatch(searchProviders({
          query: query
        }));
      }
    }, debounce);

    return function (next) {
      return function (action) {
        if (!process.browser) return next(action);
        var returnValue = next(action);

        if (action.type === updateProviderSearchQuery.getType()) {
          debouncedSearch();
        }

        return returnValue;
      };
    };
  };
});